import React from "react";
import { connect } from "react-redux";
import { Icon } from "rsuite";

class Loading extends React.Component {

  preventDefault = (e) => {
    e.preventDefault ();
    e.stopPropagation ();
  };

  //阻止滚动
  preventDefaultWheel = (bool) => {
    if (bool) {
      document.addEventListener ("wheel", this.preventDefault, { passive: false });//阻止滚动
      document.addEventListener ("touchmove", this.preventDefault, { passive: false });
    } else {
      document.removeEventListener ("wheel", this.preventDefault, false);
      document.removeEventListener ("touchmove", this.preventDefault, false);
    }
  };

  componentDidMount () {
    const { loading } = this.props;
    this.preventDefaultWheel (loading);
  }

  UNSAFE_componentWillReceiveProps (nextProps, nextContext) {
    const { loading } = nextProps;
    this.preventDefaultWheel (loading);
  }

  render () {
    const { loading, always } = this.props;
    return (
      <div>{loading || always ?
        <div className="loading_data"
             style={{ height: `${4 * (document.body.offsetHeight + window.outerHeight)}px` }}>
          <div className="loading_fix">
            <Icon icon="spinner" spin className="loading_fix_spinner"/>
          </div>
        </div> : null}</div>
    );
  }
}

const mapStateToProps = state => {
  const { globalLoading, infoLoading, visionLoading, reportLoading, historyLoading } = state.globalReducer;
  return {
    loading: globalLoading || infoLoading || visionLoading || reportLoading || historyLoading,
  };
};
export default connect (mapStateToProps) (Loading);
